import React, { useEffect, useState } from 'react'
import { archiveGovtDept, archiveGovtJobs, archiveGovtJobsResult, getGovtDeptList, getGovtJobsList, getGovtResultList } from '../../../actions/utilitiesAction'
import GovtJobList from '../../../component/Utilities/GovernmentJobs/GovtJobsList'
import constant from '../../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";
import GovtJobResultList from '../../../component/Utilities/GovernmentResult/GovtJobsResultList'


const GovtJobsResult = () => {

    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()

    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getGovtResultLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage)
        document.title = constant.title.GovtJobsList
    }, [currentPage])

    const getGovtResultLists = (page) => {
        setShowLoader(true)
        getGovtResultList(page).then((res) => {
            setShowLoader(false)
            setList(res.result.res)
            setCount(res.result.res1.total)
        }).catch((err) => {
            alert(err)
        })

    }
    const updateStatus = (model) => {
        archiveGovtJobsResult(model).then((res) => {
            if (res.status) {
                getGovtResultLists(currentPage)
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            <GovtJobResultList
                list={list}
                updateStatus={updateStatus}
                getGovtResultLists={(page => getGovtResultLists(page))}
                count={count}
                setPage={setCurrentPage}
                showLoader={showLoader}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}
export default GovtJobsResult;